module.exports = __webpack_public_path__ + "static/ben-444fedde4d2c5977a425503e5868d2e0.jpeg";